import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';

export function MonthlyReceive() {
    return (
        <section className="bg-white py-24 md:py-32" data-testid="what-you-receive">
            <div className="max-w-3xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp}>
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-navy-900 tracking-tight mb-8">
                        A Monthly Summary You'll Actually Read.
                    </h2>
                    <div className="space-y-6 text-[#6B7280] text-lg leading-relaxed">
                        <p>
                            We don't send you a raw data dump. You get a structured, written summary that tells you exactly what we found, what it means, and what we recommend. If something needs your attention, we flag it. If everything looks solid, we tell you that too.
                        </p>
                        <p>
                            This takes the management burden off your plate without taking away your visibility. You stay informed. Your VA stays accountable. And problems get caught early instead of compounding for months.
                        </p>
                    </div>

                    <div className="mt-10 rounded-sm overflow-hidden border border-gray-200 shadow-md" data-testid="screenshot-2">
                        <img
                            src="https://customer-assets.emergentagent.com/job_01a94bc3-1239-473e-9729-85c2afc85aa9/artifacts/lifapdvt_image.png"
                            alt="ScreenshotMonitoring.com - Monthly timeline showing hours worked per day with weekly and monthly totals"
                            className="w-full h-auto"
                        />
                    </div>
                    <div className="mt-6 rounded-sm overflow-hidden border border-gray-200 shadow-md" data-testid="screenshot-2b">
                        <img
                            src="https://customer-assets.emergentagent.com/job_01a94bc3-1239-473e-9729-85c2afc85aa9/artifacts/h4f6vmgd_image.png"
                            alt="ScreenshotMonitoring.com - Application usage breakdown showing time distribution across tools like Google Chrome, mail, Zoom, and other work apps"
                            className="w-full h-auto"
                        />
                    </div>
                </motion.div>
            </div>
        </section>
    );
}
